import styled from 'styled-components';

const StyledLoader = styled.div`
  width: 64px;
  height: 40px;
  position: relative;
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  grid-gap: 0 3px;
  transform: rotate(180deg);

  > div {
    background: ${({ theme }) => theme.palette.primary.main};
    height: 40px;
    width: 8px;
    display: inline-block;
    margin-right: -3px;
    animation: anm-LL-7-move infinite 1s;
    vertical-align: top;
  }
  > div:nth-child(1) {
    animation-delay: 0.3s;
  }
  > div:nth-child(2) {
    animation-delay: 0.6s;
  }
  > div:nth-child(3) {
    animation-delay: 0.9s;
  }
  > div:nth-child(4) {
    animation-delay: 1.2s;
  }
  > div:nth-child(5) {
    animation-delay: 1.5s;
  }
  @keyframes anm-LL-7-move {
    0% {
      height: 0;
    }
    15% {
      height: 12px;
    }
    35% {
      height: 8px;
    }
    45% {
      height: 24px;
    }
    75% {
      height: 40px;
    }
    100% {
      height: 24px;
    }
  }
`;

const Loader = () => (
  <StyledLoader>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </StyledLoader>
);

export default Loader;
